<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="项目ID">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入项目ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="项目名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入项目名称"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="合作类型">
              <el-select v-model="queryParams.cooperate_type" @change="search" @clear="search" placeholder="请选择合作类型" clearable class="w100">
                <el-option label="自制" value="0"></el-option>
                <el-option label="引入" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="所属团队">
              <el-select v-model="queryParams.team_id" filterable @change="search" placeholder="请选择所属团队" clearable class="w100">
                <el-option v-for="dict in teamList" :key="dict.id" :label="dict.name" :value="dict.id" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="立项时间">
              <el-date-picker
                  v-model="queryParams.project_time"
                  style="width: 100%;"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="(e)=>{this.handleChange(e,'project_time')}"
                  @clear="search"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="交付时间">
              <el-date-picker
                  v-model="queryParams.deliver_time"
                  style="width: 100%;"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="(e)=>{this.handleChange(e,'deliver_time')}"
                  @clear="search"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="IAP排期时间">
              <el-date-picker
                  v-model="queryParams.iap_time"
                  style="width: 100%;"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="(e)=>{this.handleChange(e,'iap_time')}"
                  @clear="search"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="IAA排期时间">
              <el-date-picker
                  v-model="queryParams.iaa_time"
                  style="width: 100%;"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="(e)=>{this.handleChange(e,'iaa_time')}"
                  @clear="search"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="星图排期时间">
              <el-date-picker
                  v-model="queryParams.starmap_time"
                  style="width: 100%;"
                  type="daterange"
                  align="right"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  @change="(e)=>{this.handleChange(e,'starmap_time')}"
                  @clear="search"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="请选择状态" @change="search" clearable style="width: 100%;">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="项目名称" min-width="160">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        
        <el-table-column prop="name" label="合作类型">
          <template slot-scope="scope">{{ scope.row.cooperate_type_text }}</template>
        </el-table-column>

        <el-table-column prop="name" label="所属团队">
          <template slot-scope="scope">{{ scope.row.team_name || '-' }}</template>
        </el-table-column>

        <el-table-column prop="name" label="立项时间" width="120">
          <template slot-scope="scope">{{ scope.row.project_time }}</template>
        </el-table-column>

        <el-table-column prop="name" label="交付时间" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.deliver_time==1">长期</span>
            <span v-else>{{ scope.row.deliver_time }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="iap_time" label="IAP排期时间" width="170">
          <template slot-scope="scope">{{ scope.row.iap_time || '-' }}</template>
        </el-table-column>

        <el-table-column prop="iaa_time" label="IAA排期时间" width="170">
          <template slot-scope="scope">{{ scope.row.iaa_time || '-' }}</template>
        </el-table-column>

        <el-table-column prop="starmap_time" label="星图排期时间" width="170">
          <template slot-scope="scope">{{ scope.row.starmap_time || '-' }}</template>
        </el-table-column>

        <el-table-column prop="name" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList('changePage')"/>
      <ShortPlayProjectEdit v-if="AddShortPlayProjectFlag" :AddShortPlayProjectFlag="AddShortPlayProjectFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                    :editID="editID">
      </ShortPlayProjectEdit>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import ShortPlayProjectEdit from "./edit.vue"

export default {
  components: {
    ShortPlayProjectEdit
  },
  data() {
    return {
      form: {
        name: ""
      },
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        team_id:'',
        id:'',
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
      },

      tableData: [],
      multipleSelection: [],
      dialogVisible: false,
      editID: "",
      // 总条数
      total: 0,
      AddShortPlayProjectFlag: false,
      loading: false,
      teamList: [],//团队列表
    };
  },
  created() {
    this.getList()
    this.getTeamSelectList()
  },
  methods: {

    handleChange(e,key) {
      if (Array.isArray(e) && e.length === 2) {
        // 将日期字符串转换为 Date 对象
        const date = new Date(e[0]);
        const dates = new Date(e[1]);

        // 检查 date 和 dates 是否为有效的 Date 对象
        if (!isNaN(date) && !isNaN(dates)) {
          const year = date.getFullYear();
          const years = dates.getFullYear();
          const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
          const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
          const day = ('0' + date.getDate()).slice(-2);
          const days = ('0' + dates.getDate()).slice(-2);
          const time = '00:00:00';
          const times = '23:59:59';
          const formattedDate = `${year}-${month}-${day} ${time}`;
          const formattedDates = `${years}-${months}-${days} ${times}`;
          this.queryParams[key] = [formattedDate, formattedDates];
          this.getList();
        } else {
          console.error('Invalid date objects:', date, dates);
        }
      } else {
        this.getList();
      }
    },

    getList(type) {
      this.loading = true
      if (type != 'changePage') {
        this.queryParams.pageNo = 1
      }
      let api = MoneyManagementAPI()
      api.getShortPlayProjectList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },
    // 获取团队列表
    getTeamSelectList(){
      let api = MoneyManagementAPI()
      api.getTeamSelect({status:-1}).then(res=>{
        this.teamList = res.data
      })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: "",
        team_id:'',
        id:'',
      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.AddShortPlayProjectFlag = true
    },
    NoneDlog() {
      this.AddShortPlayProjectFlag = false
    },
    AddOk() {
      this.editID = ""
      this.AddShortPlayProjectFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.AddShortPlayProjectFlag = true
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.el-form-item{
  height: 36px;
}
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>